import React from 'react';
import styled from 'styled-components';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';
import DatePicker from 'components/ui/DatePicker';
import moment from 'moment';

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

const EntryDate = ({ setFieldValue, value, errors, touched, disabled }) => {
  return (
    <Col span={12}>
      <Form.Item label={`${getTranslatedString('landlordPortal.maintenance.entryDate')}`}>
        <StyledDatePicker
          name="scheduled_at"
          size="large"
          value={value}
          defaultPickerValue={moment().locale(getCurrentLocale())}
          showToday={false}
          placeholder="e.g. 2020-01-01"
          mobileMode="date"
          onChange={(value) => setFieldValue('scheduled_at', value)}
          disabled={true}
        />
      </Form.Item>
    </Col>
  );
};

export default EntryDate;
